<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <BaseDatepickerInput v-model="archiveDateRange" ranged />
      </template>
    </Header>

    <PageContainer
      style="height: 100%"
      contentClass="checklists-forms-global-container"
    >
      <div class="no-reports" v-if="!archiveForms.length">
        <div class="qrw-heading-lg qrw-text-content-base-primary bold">
          {{ $t("checklist_reports.empty_title") }}
        </div>
        <div class="qrw-heading-md qrw-text-content-base-secondary">
          {{ $t("checklist_reports.empty_subtitle") }}
        </div>
      </div>
      <div class="reports-list">
        <div
          class="reports-list"
          v-for="(groupForms, groupDate) in groupedArchiveForms"
          :key="groupDate"
        >
          <div class="group-title gap-column-xs w-100">
            <div class="qrw-label-md qrw-text-content-tertiary">
              {{ groupDate }}
            </div>
            <BaseDivider color="border-tertiary" />
          </div>

          <ChecklistReportRow
            :form="form"
            v-for="form in groupForms"
            :key="form._id"
          />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import ChecklistReportRow from "@/components/checklists/ChecklistReportRow.vue";

import ChecklistsAPI from "@/api/checklists";

import moment from 'moment'

export default {
    data() {
        return {
            archiveDateRange: {
                start: null,
                end: null,
            },
            archiveForms: [],
        }
    },
  components: {
    ChecklistReportRow,
  },
  watch: {
    archiveDateRange: {
      deep: true,
      handler() {
        this.fetchArchiveForms();
        this.updateRouteQuery();
      },
    },
  },
  methods: {
    fetchArchiveForms() {
      ChecklistsAPI.findArchiveForms(
        this.cafe._id,
        this.archiveDateRange.start.valueOf(),
        this.archiveDateRange.end.valueOf()
      ).then((data) => {
        this.archiveForms = data.forms;
      });
    },
    updateRouteQuery() {
      const query = {};

      query.start = this.archiveDateRange.start.valueOf();
      query.end = this.archiveDateRange.end.valueOf();

      this.$router.replace({
        name: "checklist_reports",
        query,
      });
    },
  },
  mounted() {
    if (this.$route.query.start) {
      this.archiveDateRange.start = new Date(+this.$route.query.start);
      this.archiveDateRange.end = new Date(+this.$route.query.end);
    } else {
      this.archiveDateRange.start = moment()
        .startOf("day")
        .toDate();
      this.archiveDateRange.end = moment()
        .endOf("day")
        .toDate();
    }

    this.fetchArchiveForms();
  },
  computed: {
    groupedArchiveForms() {
      let groups = {};

      for (const form of this.archiveForms) {
        const key = moment(form.completed_at).format("DD.MM.YYYY");

        if (!groups[key]) groups[key] = [];

        groups[key].push(form);
      }

      return groups;
    },
  },
};
</script>

<style scoped>
.no-reports {
  display: flex;
  height: 100%;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 16px;
}

.reports-list {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.group-title {
  align-items: center;
}
</style>
